<ca-modal-container modalTitle="{{ title }}" (dismiss)="dismiss()" data-uit="check-existence-of-item-dialog">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
        <div>
            <div class="d-flex flex-column-reverse">
                <input
                    id="name-input"
                    type="text"
                    class="form-control"
                    formControlName="name"
                    required
                    data-uit="check-existence-of-item-dialog-input"
                    [ngClass]="formGroup.get('name')?.errors && formGroup.get('name')?.dirty ? 'has-error' : ''"
                />
                <label for="name-input">{{ inputLabel }}</label>
            </div>
            <div class="mt-1">
                <ca-list-progress-bar
                    [isShown]="formGroup.status === 'PENDING'"
                    class="w-100"
                    data-uit="check-existence-of-item-dialog-ca-list-progress-bar"
                ></ca-list-progress-bar>
            </div>
            <small *ngIf="formGroup.get('name')?.dirty && formGroup.get('name')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
            <small *ngIf="formGroup.get('name')?.dirty && formGroup.get('name')?.hasError('pattern')" class="invalid-feedback">
                {{ 'GENERAL.NOT_CONTAINING_ONLY_WHITESPACES' | translate }}
            </small>
            <small
                *ngIf="formGroup.get('name')?.dirty && formGroup.get('name')?.hasError('errorFolderAlreadyExists')"
                class="invalid-feedback"
                data-uit="check-existence-of-item-dialog-error-folder-already-exists"
            >
                {{ 'MY_WORKSPACE.MY_FILES.FOLDER_WITH_THE_SAME_NAME_ALREADY_EXISTS' | translate: { folderName: formGroup.value.name } }}
            </small>
            <small *ngIf="formGroup.get('name')?.dirty && formGroup.get('name')?.hasError('errorFolderCheckExistence')" class="invalid-feedback">
                {{ 'MY_WORKSPACE.MY_FILES.ERROR_FOLDER_CHECK_EXISTENCE' | translate }}
            </small>
        </div>
        <div class="mt-4">
            <button
                type="submit"
                caAutoFocus
                class="btn btn-primary w-100"
                [disabled]="!formGroup.valid || oldName === formGroup.get('name')?.value"
                (click)="submit()"
                data-uit="check-existence-of-item-dialog-ok-button"
            >
                {{ confirmText }}
            </button>
        </div>
    </form>
</ca-modal-container>
